export default __webpack_public_path__ + "2dc12a85a6bbc7719972f65ad7a5f793.svg";